import types from "./types";
import connection from "../api/config/connection";
import map from "../api/mapping/storingen";

const request = () => ({
  type: types.REQUEST_DIENSTREGELING,
});
const received = (dienstregeling) => ({
  type: types.RECEIVED_DIENSTREGELING,
  dienstregeling,
});
const failed = () => ({
  type: types.REQUEST_DIENSTREGELING_FAILED,
});

const setDirection = (directionId) => ({
  type: types.SET_DIENSTREGELING_DIRECTION,
  directionId,
});

const requestDisruptions = (url, agencyId, routeId) => (dispatch) => {
  dispatch({
    type: types.REQUEST_DIENSTREGELING_DISRUPTIONS,
  });

  if (!url || !agencyId || !routeId) {
    console.error(
      "Cannot request dienstregeling disruptions. Missing url, agencyId or routeId."
    );
    dispatch(failedDisruptions());
    return;
  }

  const options = {
    method: "GET",
    url,
    params: {
      agencyIds: agencyId,
    },
  };

  connection
    .instance()(options)
    .then((response) => {
      let results = [];
      try {
        results = response.data || [];
      } catch (ex) {}

      let storingen = map(results);
      const alertsInfo = storingen.filter(
        (result) =>
          !!(result.routes || []).find((route) => route.route_id === routeId)
      );
      dispatch(receivedDisruptions(alertsInfo));
    })
    .catch((xhr) => {
      dispatch(failedDisruptions());
    });
};

const requestStopDisruptions = (url, agencyId, routeIds) => (dispatch) => {
  dispatch({
    type: types.REQUEST_DIENSTREGELING_DISRUPTIONS,
  });

  if (!url || !agencyId || !routeIds) {
    console.error(
      "Cannot request stop disruptions. Missing url, agencyId or routeIds."
    );
    dispatch(failedDisruptions());
    return;
  }

  const options = {
    method: "GET",
    url,
    params: {
      agencyIds: agencyId,
    },
  };

  connection
    .instance()(options)
    .then((response) => {
      let results = [];
      try {
        results = response.data || [];
      } catch (ex) {}

      let storingen = map(results);
      const alertsInfo = storingen.filter((result) =>
        result.routes.find((route) =>
          routeIds.find((id) => route.route_id == id)
        )
      );
      dispatch(receivedDisruptions(alertsInfo));
    })
    .catch((xhr) => {
      dispatch(failedDisruptions());
    });
};

const receivedDisruptions = (alertsInfo) => ({
  type: types.RECEIVED_DIENSTREGELING_DISRUPTIONS,
  alertsInfo,
});
const failedDisruptions = () => ({
  type: types.REQUEST_DIENSTREGELING_DISRUPTIONS_FAILED,
});

const setLoading = (loading) => ({
  type: types.DIENSTREGELING_LOADING,
  loading: loading,
});

export default {
  request,
  received,
  failed,
  setDirection,
  requestDisruptions,
  requestStopDisruptions,
  receivedDisruptions,
  failedDisruptions,
  setLoading,
};



// WEBPACK FOOTER //
// ./src/actions/dienstregeling.js